<script>
import { Line } from "vue-chartjs";
export default {
  extends: Line,
  props: ["data"],
  mounted() {
    var s1 = [];
    var s2 = [];
    for (var item of this.data) {
      s1.push(item.title);
      s2.push(item.value);
    }

    this.renderChart(
      {
        labels: s1,
        datasets: [
          {
            label: "Data One",
           
            data: s2
          }
        ]
      },
      { responsive: true, maintainAspectRatio: false }
    );
  },
  watch: {
    data(v) {
      var s1 = [];
      var s2 = [];
      for (var item of v) {
        s1.push(item.title);
        s2.push(item.value);
      }

      this.renderChart(
        {
          labels: s1,
          datasets: [
            {
              label: "",
              backgroundColor: "#D0DCFF",
              data: s2
            }
          ]
        },
        { responsive: true, maintainAspectRatio: false }
      );
    }
  }
};
</script>

